import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import PrivateRoute from "./services/PrivateRouter";
import App from "./App";
import {
  ActivityRoutes,
  AdminSettingsRoutes,
  AuthRoutes,
  InformationRoutes,
  MainpageRoutes,
  ReferenceDocRoutes,
  StandardSettingsRoutes,
} from "./routes";
import StandardMain from "./layouts/StandardMain";
import { StandardDashboard } from "./pages/Standard";
import PageNotFound from "./components/View/PageNotFound";
import Helpindex from "./pages/help";
import HelpMain from "./layouts/HelpMain";
import MainReports from "./pages/Reports/MainReports";
import {
  AuditScheduleReport,
  GenarateReport,
  ImplementationChecklistReport,
  InternalAuditChecklistReport,
  InternalAuditReport,
  MaintenanceReport,
  MasterListofDocumentsReport,
  MRMReport,
  OverAllProgressIndex,
  PreDefinedReport,
  PreDefineMain,
  SecurityIncidentReport,
  TrainingCalendarReport,
  VendorManagementReport,
} from "./pages/Reports";

function Mainroutes() {
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname === "/" ||
      location.pathname === "" ||
      location.pathname === "main"
    ) {
      window.location.replace("/main/standard");
    }
    if (location.pathname === "/auth") {
      window.location.replace("/auth/login");
    }
  }, [location]);
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <App />
          </PrivateRoute>
        }
      >
        {MainpageRoutes()}
        {AdminSettingsRoutes()}
        <Route path="standard/:stdId" element={<StandardMain />}>
          <Route path="dashboard" element={<StandardDashboard />} />
          <Route path="reference-doc/*" element={<ReferenceDocRoutes />} />
          <Route path="information/*" element={<InformationRoutes />} />
          <Route path="activity/*" element={<ActivityRoutes />} />
          <Route path="settings/*" element={<StandardSettingsRoutes />} />
          <Route path="report" element={<MainReports />}>
            <Route
              path="internal-audit-report"
              element={<InternalAuditReport />}
            />
            <Route path="genarate-report" element={<GenarateReport />} />
            <Route path="pre-defined-report" element={<PreDefinedReport />} />
            <Route path="pre-defined" element={<PreDefineMain />}>
              <Route path="overallprogress" element={<OverAllProgressIndex/>} />
              <Route
                path="vendor-management-report"
                element={<VendorManagementReport />}
              />
              <Route
                path="security-incident-report"
                element={<SecurityIncidentReport />}
              />
              <Route
                path="training-calendar-report"
                element={<TrainingCalendarReport />}
              />
              <Route
                path="implementationckeck-list-report"
                element={<ImplementationChecklistReport />}
              />
              <Route
                path="internal-audit-report"
                element={<InternalAuditChecklistReport />}
              />
              <Route
                path="maintenance-report"
                element={<MaintenanceReport />}
              />
              <Route path="master-report" element={<MasterListofDocumentsReport/>} />
              <Route path="mrm-report" element={<MRMReport/>} />
              <Route
                path="audit-schedule-report"
                element={<AuditScheduleReport/>}
              />
            </Route>
          </Route>
        </Route>
        <Route path="help" element={<HelpMain />}>
          <Route index element={<Helpindex />} />
          <Route path=":stdId" element={<Helpindex />} />
        </Route>
      </Route>
      {AuthRoutes()}
      <Route path="/*" element={<PageNotFound />} />
    </Routes>
  );
}

export default Mainroutes;
